/* eslint-disable no-multi-assign */
module.exports = exports = {
  Post: ['title', 'slug', 'content', 'perex', 'metaDesc'],
  Project: ['title', 'slug', 'content', 'perex', 'metaDesc'],
  Person: ['position', 'perex'],
  Document: ['title'],
}
